interface CountryFlagProps {
    code: string;
    className?: string;
    width?: number;
    height?: number;
}

const CountryFlag = ({
    code,
    className = "login-flag",
    width = 20,
    height = 15,
}: CountryFlagProps) => (
    <img
        className={className}
        src={`https://flagcdn.com/w40/${code}.png`}
        srcSet={`https://flagcdn.com/w80/${code}.png 2x`}
        alt=""
        width={width}
        height={height}
    />
);

export default CountryFlag;
